export default __webpack_public_path__ + "static/media/vi_share_your_bank_statement.f6456c7c.svg";